// This should be replaced by offer as soon as the client can access This
export default offerCtrl

/** @ngInject */
function offerCtrl(AlertManager, $scope, $state, $uibModal) {
    $scope.openLinkyModal = () =>
        $uibModal.open({
            animation: true,
            size: 'lg',
            controller: 'linkyModalCtrl',
            template: require('./view.jade')(),
        })
}



// WEBPACK FOOTER //
// ./src/states/offer/controller.js